import EditEmailTemplate from './EditEmailTemplate';

export default EditEmailTemplate;
